


















import {AxiosError, AxiosResponse} from 'axios';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {CONFIG} from '@/config';
import moment from 'moment';

import {httpService} from '@/services';

@Component({
  components: {}
})
export default class RetailSalesPerformance extends Vue {
  @Prop({required: true})
  dataQuery: any;

  public totalYears: number = 3;

  @Watch('dataQuery')
  public requestData() {
    this.getExcelRetailSalesPerformance();
  }

  private getExcelRetailSalesPerformance() {
    const parameters = {
      yearInitial: this.dataQuery.ano_inicial.value,
      yearFinal: this.dataQuery.ano_final.value,
      monthInitial: this.dataQuery.mes_inicial.value,
      monthFinal: this.dataQuery.mes_final.value,
      reportType: 5,
      typeExtensionReport: 3
    };

    httpService.httpBlob
        .post(`${CONFIG.URL.NEODASH_API}/api/dap/approval/retailSalesPerformance/xlsx/`, parameters)
        .then((res: AxiosResponse) => {
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });

          kendo.saveAs({
            dataURI: window.URL.createObjectURL(blob),
            fileName: `Retail_Sales_Performance` + moment(new Date()).format('YYYY_MM_DD-hh_mm_ss') + `.xlsx`
          });
        })
        .catch((err: AxiosError) => {
          console.log('Error', err);
        });
  }

  public created() {
    this.requestData();
  }
}
